import { __read } from "tslib";
import * as u from './urx';
import { empty } from './AATree';
import { sizeSystem } from './sizeSystem';
import { domIOSystem } from './domIOSystem';
import { scrollToIndexSystem } from './scrollToIndexSystem';
import { propsReadySystem } from './propsReadySystem';
import { skipFrames } from './utils/skipFrames';
export function getInitialTopMostItemIndexNumber(location, totalCount) {
    var lastIndex = totalCount - 1;
    var index = typeof location === 'number' ? location : location.index === 'LAST' ? lastIndex : location.index;
    return index;
}
export var initialTopMostItemIndexSystem = u.system(function (_a) {
    var _b = __read(_a, 4), _c = _b[0], sizes = _c.sizes, listRefresh = _c.listRefresh, defaultItemSize = _c.defaultItemSize, scrollTop = _b[1].scrollTop, scrollToIndex = _b[2].scrollToIndex, didMount = _b[3].didMount;
    var scrolledToInitialItem = u.statefulStream(true);
    var initialTopMostItemIndex = u.statefulStream(0);
    var scrollScheduled = u.statefulStream(false);
    u.connect(u.pipe(didMount, u.withLatestFrom(initialTopMostItemIndex), u.filter(function (_a) {
        var _b = __read(_a, 2), _ = _b[0], location = _b[1];
        return !!location;
    }), u.mapTo(false)), scrolledToInitialItem);
    u.subscribe(u.pipe(u.combineLatest(listRefresh, didMount), u.withLatestFrom(scrolledToInitialItem, sizes, defaultItemSize, scrollScheduled), u.filter(function (_a) {
        var _b = __read(_a, 5), _c = __read(_b[0], 2), didMount = _c[1], scrolledToInitialItem = _b[1], sizeTree = _b[2].sizeTree, defaultItemSize = _b[3], scrollScheduled = _b[4];
        return didMount && (!empty(sizeTree) || u.isDefined(defaultItemSize)) && !scrolledToInitialItem && !scrollScheduled;
    }), u.withLatestFrom(initialTopMostItemIndex)), function (_a) {
        var _b = __read(_a, 2), initialTopMostItemIndex = _b[1];
        u.publish(scrollScheduled, true);
        skipFrames(3, function () {
            u.handleNext(scrollTop, function () { return u.publish(scrolledToInitialItem, true); });
            u.publish(scrollToIndex, initialTopMostItemIndex);
        });
    });
    return {
        scrolledToInitialItem: scrolledToInitialItem,
        initialTopMostItemIndex: initialTopMostItemIndex,
    };
}, u.tup(sizeSystem, domIOSystem, scrollToIndexSystem, propsReadySystem), { singleton: true });
